import styled from "styled-components";

export const TimeZoneContainer = styled.div`
  width: 525px;
  height: 372px;
  border: 1px solid var(--hv-border-default);
  box-shadow: var(--hv-shadow-4);
  background-color: var(--hv-surface-popup);
  border-radius: 12px;
  position: relative;
  margin-top: 4px;
`;

export const TimeZoneContent = styled.div<{ hasActive?: boolean }>`
  cursor: pointer;
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  border-left: 2px solid transparent;
  padding: 0px 20px;
  ${({ hasActive }) =>
    hasActive &&
    ` {
    background-color: var(--hv-interaction-select-gray);
    border-color: var(--hv-interaction-select-orange);
    border-radius: 0;
  }`}
  &:hover {
    background-color: var(--hv-interaction-hover);
  }
`;

export const Divider = styled.div`
  width: calc(100% - 40px);
  height: 1px;
  background-color: var(--hv-border-default);
  margin-left: 20px;
`;

export const TimeZoneHeaderContent = styled.div`
  padding: 12px 20px;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const TimeZoneMiddleContent = styled.div`
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const TimezoneList = styled.div`
  height: 300px;
`;

export const UserTimeZone = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
